export default __webpack_public_path__ + "796983e7e5ba3ebf628dfef20b672c21.svg";